import View from "../account/views/BankAccountView";
import components from "./components.js";
components.define("js-bank-page", View);